import api from "@core/plugins/api";
import { ArrayHelpers } from "@core/helpers";

const cancelDemandAEUrl = (demandId) => `/api/et/recrutement/annule/etab/${demandId}`;
const cancelDemandUrl = (demandId) => `/api/et/demande/annule/${demandId}`;
const cancelDemandAfterCreationUrl = (demandId) => `/demand/et/cancel-demand-cdi/${demandId}`;
const getByIdUrl = (demandId) => `/api/et/recruitment/${demandId}`;
const getLinkedIdUrl = (masterId, extraId) => `/api/et/demande/mere/${masterId}/extra/${extraId}`;
const recapDemandPermanentUrl = (demandId) => `/api/et/recap-cdi/${demandId}`;
const recruitmentsListUrl = (current) => `/et/etab-recruitment?hasStarted=${current}`;
const restartDemandAEUrl = (missionId) => `/api/et/recruitment/reload/${missionId}`;
const recruitmentsNumberUrl = () => `/api/et/number/recruitment`;
const getRecruitmentDetailUrl = (demandId, demandType) => `/api/et/recruitment/${demandType}/${demandId}`;

export class RecruitmentsService {
  static async getAll({ current = false }) {
    try {
      const response = await api.private.get(recruitmentsListUrl(current));
      const list = response && response.data;
      // api returns empty object instead of empty array sometimes
      // so let's be sure we have an array before sending to the front
      return ArrayHelpers.ensureArray(list);
    } catch (error) {
      throw error;
    }
  }

  static async getNumbers() {
    try {
      const response = await api.private.get(recruitmentsNumberUrl());
      return response && response.data;
    } catch (error) {
      throw error;
    }
  }

  static async getById({ demandId }) {
    try {
      const response = await api.private.get(getByIdUrl(demandId));
      const demand = response && response.data;
      return demand;
    } catch (error) {
      throw error;
    }
  }

  static async getRecruitmentDetail({ demandId, demandType }) {
    try {
      const { data } = await api.private.get(getRecruitmentDetailUrl(demandId, demandType.toUpperCase()));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getLinkedId({ masterId, extraId }) {
    try {
      const response = await api.private.get(getLinkedIdUrl(masterId, extraId));
      const { idDemandeFille } = response && response.data;
      return idDemandeFille;
    } catch (error) {
      throw error;
    }
  }

  static async getRecap({ demandId }) {
    try {
      const url = recapDemandPermanentUrl(demandId);
      const { data } = await api.private.get(url);
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async cancelPermanentDemand({ demandId }) {
    try {
      const { data } = await api.private.post(cancelDemandUrl(demandId));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async cancelAEDemand({ missionId }) {
    try {
      const { data } = await api.private.get(cancelDemandAEUrl(missionId));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async cancelDemandAfterCreation({ demandId }) {
    try {
      const { data } = await api.private.post(cancelDemandAfterCreationUrl(demandId));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async restartDemand({ recruitment }) {
    try {
      let response;
      if (recruitment.isAE() || recruitment.isInterim()) {
        response = await api.private.post(restartDemandAEUrl(recruitment.getMissionId()));
      }
      if (response === undefined) {
        throw new Error("WRONG RECRUITMENT TYPE");
      }
      return response && response.data;
    } catch (error) {
      throw error;
    }
  }
}
